<!-- Spinner Start -->
@if (showSpinnerInProductSelection) {
  <div class="overlay">
    <div cbPageSpinner colorTheme="default" sizeVariant="large">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>
}
<!-- Spinner End -->

@if (showProductsView) {
  <div>
    @if (noProductsSelected || (products && products.length <= 0)) {
      <div class="container no-products">
        <div class="section-body">
          <!-- <app-coverhound [referralType]="noProducts" [partnerId]="1"></app-coverhound> -->
          <app-referral-message
            [isRetrieveQuote]="false"
            [noAppetite]="isNoAppetite"
          ></app-referral-message>
        </div>
      </div>
    }
    @if (!noProductsSelected && products && products.length > 0) {
      <div class="container">
        <div class="steps-container">
          <section class="steps-sections__progress-bar">
            <app-progress-bar></app-progress-bar>
          </section>
          <section class="steps-sections products-layout product-wrapper">
            <div class="steps-sections-body">
              <h1 class="products-layout-title">
                {{labelDictionary.productsText}}
              </h1>
              <!-- No feature product -->
              <!-- not offer building Coverage With BOP -->
              @if (showNotificationBuildingCov) {
                <div class="buildingCoverage">
                  <div class="buildingCoverage-left">
                    <img src="../../../../assets/img/icons/buildingCoverage-caution.png">
                  </div>
                  <div class="buildingCoverage-right">{{labelDictionary.showNotificationBuildingCovWithbop}}</div>
                </div>
              }
              <div class="clear"></div>
              <!-- Product tile-->
              <div class="products-container">
                <app-products-tile [inputProducts]="sortedProducts"
                  (emitUmbrellaError)="readEmittedUmbrellaError($event)"
                  [showUmbrellaError]="showUmbrellaError" (selectedProduct)="selectProduct($event)">
                </app-products-tile>
              </div>
            </div>
            <div class="clear"></div>
            <div [class]="nonFeaturedProducts.length > 1 ? 'quote-all-and-next-btn' :'next-btn-solo'">
              <!-- <button class="quote-all-product"
              *ngIf="!hideQuoteAll"
              type="button"
              (click)="continueToQuestions(true)">
              Quote all products
            </button> -->
            <div class="show-back-btn">
              <button class="back-btn" [routerLink]="['/get-a-quote']">
                Back
              </button>
              @if (enableNext) {
                <button class="continue-btn-btn" [disabled]="!enableNext" type="button"
                  (click)="continueToQuestions(false)">
                  Continue
                </button>
              }
            </div>
          </div>
        </section>
      </div>
    </div>
  }
</div>
}
